import { generateTestId } from "@client-shared";

export const setBatchSummaryTestId = (identifier: string): string =>
  generateTestId("BatchSummary", identifier);

// Specific testId setters for tests
export const setBatchSummaryContainerTestId = (): string =>
  setBatchSummaryTestId("container");
export const setBatchSummaryBatchIdTestId = (): string =>
  setBatchSummaryTestId("batch-id");
